import { render, staticRenderFns } from "./ImageRatioMolecule.vue?vue&type=template&id=236dd433&"
import script from "./ImageRatioMolecule.vue?vue&type=script&lang=ts&"
export * from "./ImageRatioMolecule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports